import { createCMSQuery } from '../../cms';
import { getLocalizedPath } from '../helpers';

export type FaqItem = {
  question: string;
  answer: string;
};

export interface ISeoContentResponse {
  path: string;
  locale: string;
  contentV2?: string;
  faqItems?: FaqItem[];
}

export type SeoContentResult = {
  content?: string;
  faqItems?: FaqItem[];
};

export const getSeoContentUrl = (locale: string, routePath: string) => {
  const seoQuery = createCMSQuery({
    filters: { path: { $eq: getLocalizedPath(locale, routePath) } },
    populate: {
      faq_items: true,
    },
  });

  return `/seo-contents/?${seoQuery}`;
};

export const formatDescriptionV2Html = (htmlString?: string) => {
  if (!htmlString) return;

  return htmlString
    .trim()
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(
      /<table(\s[^>]*)?>/gi,
      (_, attrs) => `<div style="overflow-x:auto"><table${attrs ?? ''}>`
    )
    .replace(/<\/table>/gi, '</table></div>')
    .replace(
      /<img(\s[^>]*)?>/gi,
      (_, attrs) => `<div class="img-wrapper"><img${attrs ?? ''}></div>`
    );
};

export const mapSeoContent = (
  data?: ISeoContentResponse
): SeoContentResult | null => {
  const content = formatDescriptionV2Html(data?.contentV2);
  const faqItems = data?.faqItems;

  if (!(content || faqItems?.length)) {
    return null;
  }

  return { content, faqItems };
};
